import { render, staticRenderFns } from "./Top-Bar.vue?vue&type=template&id=3a40e79c&scoped=true&"
import script from "./Top-Bar.vue?vue&type=script&lang=js&"
export * from "./Top-Bar.vue?vue&type=script&lang=js&"
import style0 from "./Top-Bar.vue?vue&type=style&index=0&id=3a40e79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a40e79c",
  null
  
)

export default component.exports